import {
  DASHBOARD_PERMISSION_CHANGED_BODY_KEYS,
  DASHBOARD_SHARED_BODY_KEYS,
} from "../constants/notifications";
import { EDashboardShareRole } from "../types/dashboards";
import type {
  TDashboardPermissionChangedBodyKey,
  TDashboardSharedBodyKey,
} from "../types/notifications";

const DASHBOARD_SHARE_ROLES: readonly string[] =
  Object.values(EDashboardShareRole);

export const isDashboardShareRole = (
  value: string,
): value is EDashboardShareRole => DASHBOARD_SHARE_ROLES.includes(value);

// NOTE: NSAI-6940 — the wire carries `permissionLevel` as a free string so an
// older client survives a role the server adds later. Such a role reads as the
// viewer sentence: the card must never claim more access than was granted.
const toKnownShareRole = (permissionLevel: string): EDashboardShareRole =>
  isDashboardShareRole(permissionLevel)
    ? permissionLevel
    : EDashboardShareRole.VIEWER;

export const resolveDashboardSharedBodyKey = (
  permissionLevel: string,
): TDashboardSharedBodyKey =>
  DASHBOARD_SHARED_BODY_KEYS[toKnownShareRole(permissionLevel)];

export const resolveDashboardPermissionChangedBodyKey = (
  permissionLevel: string,
): TDashboardPermissionChangedBodyKey =>
  DASHBOARD_PERMISSION_CHANGED_BODY_KEYS[toKnownShareRole(permissionLevel)];
